export default __webpack_public_path__ + "static/media/property_10.7a7331bf.png";